import patternize from '@sdk/helpers/formatters/patternize';

export const ZIP_REGEX = /^[0-9]{5}-[0-9]{3}$/;
export const ZIP_FORMAT = '#####-###';

export default function zip(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (ZIP_REGEX.test(patternize(value, { format: ZIP_FORMAT }))) {
    return false;
  }

  return true;
}

zip.message = function message(value, options = {}) {
  return options.message || 'não é um CEP válido';
};
